document.addEventListener('DOMContentLoaded', function() {

  // Show all variants
  const showAllVariantsBtn = document.querySelector('.product-pro__show-all');
  if (showAllVariantsBtn) {
    showAllVariantsBtn.addEventListener('click', function(e) {
      const hiddenVariants = document.querySelectorAll('.product-pro-variant.hidden');
      for (const variant of hiddenVariants) {
        variant.classList.remove('hidden');
      }
      e.target.remove();
    });
  }
});